import React, { useCallback, useEffect, useRef, useState } from "react";

import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

import { Button } from "studio-design-system";

//import * as styles from "./HeaderButtons.css";
import * as styles from "./SelectableDropdown.css";

export interface HeaderButtonProps {
  label?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  custom?: React.ReactNode;
}

interface Props {
  selectableValues: Array<string>;
  handleSelect: (value: string) => void;
}

export const SelectableDropdown = ({ selectableValues, handleSelect }: Props) => {
  const [showSelect, setShowSelect] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [selectValuesData, setSelectValuesData] = useState(selectableValues);

  return (
    <div className={styles.selectInput} onClick={() => setShowSelect((show) => !show)}>
      <div
        className={classNames(
          styles.dropdownIcon,
          showSelect ? styles.dropdownIconRevert : undefined,
        )}
      >
        <Image src={"/dropdown-icon.svg"} width={13} height={8} alt="dropdownIcon" />
      </div>
      {selectValue ? (
        <>
          <span className={styles.selectValue}>{selectValue}</span>
        </>
      ) : (
        <span className={styles.selectValue}>Select option</span>
      )}

      {showSelect && (
        <ul className={styles.selectList}>
          {selectValuesData &&
            selectValuesData.map((item, index) => {
              return (
                <li
                  key={index}
                  className={classNames(
                    styles.selectItem,
                    selectValue === item ? styles.selectItemActive : undefined,
                  )}
                  onClick={(e) => {
                    setSelectValue(item);
                    handleSelect(item);
                  }}
                >
                  {item}
                </li>
              );
            })}
        </ul>
      )}
    </div>
  );
};
